import isEqual from 'lodash/isEqual';

import emptyNode from '@ui/MarkdownEditor/emptyNode';

import { isCallout, calloutType, type } from './shared';

export const deserialize = ({ data, position, ...node }, deeper, { renderingLibrary }) => {
  const { hName } = data || {};
  const { icon, title, theme, empty = false } = data?.hProperties || {};
  const children = deeper(node);

  if (icon && !title?.length && hName !== 'Callout') {
    children.unshift({ type: 'paragraph', children: [{ text: title || '' }] });
  }

  if ('mdx' in renderingLibrary && empty && isEqual(emptyNode(), children[0])) {
    children.shift();
  }

  return icon
    ? { ...node, icon, type, empty, ...(theme && { theme }), children }
    : { ...node, ...(theme && { theme }), type, children };
};

export const serialize = (node, deeper) => {
  const { icon, theme } = node;
  const nodeType = isCallout(node) ? calloutType : type;

  return {
    ...node,
    type: nodeType,
    children: deeper(node),
    data: {
      hName: nodeType,
      hProperties: {
        icon,
        theme,
      },
    },
  };
};
